import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=3b513659&scoped=true"
import script from "./DateFilter.vue?vue&type=script&lang=js"
export * from "./DateFilter.vue?vue&type=script&lang=js"
import style0 from "./DateFilter.vue?vue&type=style&index=0&id=3b513659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b513659",
  null
  
)

export default component.exports